// Load default Webentor JS features
import './_header';
import './_blobs';
import './_anchor-offset';

import Lightbox from './_lightbox';

// Register Alpine last to ensure all extensions are registered
import './_alpine';
import './blocks-components/_print-button';

// Register static assets
import.meta.glob(['../images/**', '../fonts/**'], {
  eager: true,
  query: '?url',
  import: 'default',
});

new Lightbox();
new Lightbox('.lightgallery-gallery', {
  selector: undefined,
});

// Scroll to next section on Hero "show more" click
document.addEventListener('DOMContentLoaded', () => {
  const heroShowMore = document.querySelector('.js-hero-show-more');
  if (heroShowMore) {
    heroShowMore.addEventListener('click', () => {
      const hero = heroShowMore.closest('.hero');

      const nextSection = hero?.nextElementSibling;
      if (nextSection) {
        const offset = 100;
        const y =
          nextSection.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  }
});
